import { useParams, useNavigate } from 'react-router-dom'
import { SECTIONS } from '../../data/sections'
import { MANTRAS } from '../../data/mantras'
import { DESC } from '../../data/descriptors'
import ICONS from '../../data/icons'
import type { SectionId, Category, Tool, CategoryIcon } from '../../types/tools'
import NavBack from '../base/NavBack'
import ToolCard from './ToolCard'

export default function CategoryPage() {
  const { sectionKey, categoryKey } = useParams<{ sectionKey: string; categoryKey: string }>()
  const navigate = useNavigate()

  const section = SECTIONS[sectionKey as SectionId]
  const category: Category | undefined = section
    ? (section.cats as unknown as Record<string, Category>)[categoryKey!]
    : undefined

  if (!section || !category) {
    return (
      <div className="cat-page" data-testid="category-not-found">
        <p>Category not found.</p>
        <button className="btn" onClick={() => navigate('/')} data-testid="category-back-btn">
          Back to dashboard
        </button>
      </div>
    )
  }

  const mantra = MANTRAS[categoryKey!] ?? ''
  const toolEntries = Object.entries(category.tools) as Array<[string, Tool]>
  const icon = ICONS[category.icon as CategoryIcon]

  return (
    <div className="cat-page" data-testid="category-page">
      <NavBack label="All Topics" onClick={() => navigate('/')} />

      <div className="cat-header" data-testid="category-header">
        <div
          className="cat-header-icon"
          style={{ background: 'var(--blue-pl)', color: 'var(--blue)' }}
          data-testid="category-header-icon"
        >
          {icon}
        </div>
        <div>
          <div className="cat-header-sec" data-testid="category-super-header">Teamship Tools</div>
          <h1 className="cat-header-title" data-testid="category-header-title">
            {category.label}
          </h1>
          {mantra && (
            <div className="cat-header-mantra" data-testid="category-header-mantra">
              &ldquo;{mantra}&rdquo;
            </div>
          )}
        </div>
      </div>

      <div className="cat-tools" data-testid="category-tool-list">
        {toolEntries.map(([toolKey, tool], index) => {
          const desc = DESC[toolKey]
          let snippet = desc?.what ?? ''
          if (snippet.length > 100) snippet = snippet.substring(0, 100) + '\u2026'

          return (
            <ToolCard
              key={toolKey}
              index={index}
              toolKey={toolKey}
              label={tool.l}
              description={snippet}
              onClick={() => navigate(`/tool/${sectionKey}/${categoryKey}/${toolKey}`)}
            />
          )
        })}
      </div>
    </div>
  )
}
